var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-downloads"},[_c('div',{staticClass:"dev-downloads-content"},[_c('Collapse',{attrs:{"title":"Descargas","settings":{ opened: true }}},_vm._l((_vm.downloads),function(item,index){return _c('Download',{key:index,attrs:{"download":item.data}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }